import { Card } from 'react-bootstrap';
import { Divider } from '@mui/material';
import { useFormikContext } from 'formik';

import { Step1, Step2, Step3, Step4, Step5, Step6 } from './Steps';
import { Footer } from '../components';

const PreviewLeaseByManager = () => {
  const { values } = useFormikContext();
  const steps = [
    { label: 'Step 1', component: <Step1 lease={values} /> },
    { label: 'Step 2', component: <Step2 lease={values} /> },
    { label: 'Step 3', component: <Step3 lease={values} /> },
    { label: 'Step 4', component: <Step4 lease={values} /> },
    { label: 'Step 5', component: <Step5 lease={values} /> },
    { label: 'Step 6', component: <Step6 lease={values} /> },
  ];

  return (
    <Card className="shadow-lg p-5 lease-form" style={{ backgroundColor: 'white' }}>
      <Card.Body>
        {steps.map((step, index) => (
          <div key={index} className="mb-4 lease-step">
            {step.component}
            <Footer values={values} page={index + 1} />
            {index < steps.length - 1 && (
              <Divider sx={{ my: 4, borderColor: 'gray' }} />
            )}
          </div>
        ))}
      </Card.Body>
    </Card>
  );
};

export { PreviewLeaseByManager };
